import { Injectable, effect, signal } from "@angular/core";

import { Supabase, type Tables } from "@app/@classes/supabase";
import { BehaviorSubject, Subject, from, map } from "rxjs";

const TABLE = "companies";
type T = typeof TABLE;

@Injectable({
	providedIn: "root",
})
export class PalmtopService extends Supabase {
	public readonly currentCompanyId$: BehaviorSubject<string | undefined>;
	public readonly nameChange$: Subject<string> = new Subject<string>();
	public readonly currentCompanyInfo$: BehaviorSubject<Tables<T> | undefined>;

	public readonly currentCompanyId = signal<string | undefined>(undefined);
	public readonly currentCompanyInfo = signal<Tables<T> | undefined>(undefined);

	public readonly currentWarehouseId$: BehaviorSubject<string | undefined>;
	public readonly currentWarehouseId = signal<string | undefined>(undefined);

	constructor() {
		super();

		const currentCompanyId: string | null = this.getCompanyId();
		if (currentCompanyId) {
			this.currentCompanyId.set(currentCompanyId);
			this.currentCompanyId$ = new BehaviorSubject<string | undefined>(
				currentCompanyId,
			);
		} else {
			this.currentCompanyId.set(undefined);
			this.currentCompanyId$ = new BehaviorSubject<string | undefined>(
				undefined,
			);
		}

		this.currentCompanyInfo$ = new BehaviorSubject<Tables<T> | undefined>(
			undefined,
		);

		effect(() => {
			const id = this.currentCompanyId();

			this.currentCompanyId$.next(id);

			if (id && id !== undefined && id !== null) {
				this.loadCompanyInfo(id);
			} else {
				this.currentCompanyInfo.set(undefined);
			}
		});

		effect(() => {
			this.currentCompanyInfo$.next(this.currentCompanyInfo());
		});

		const currentWarehouseId: string | null = this.getWarehouseId();

		if (currentWarehouseId) {
			this.currentWarehouseId.set(currentWarehouseId);
			this.currentWarehouseId$ = new BehaviorSubject<string | undefined>(
				currentWarehouseId,
			);
		} else {
			this.currentWarehouseId.set(undefined);
			this.currentWarehouseId$ = new BehaviorSubject<string | undefined>(
				undefined,
			);
		}
		effect(() => {
			const id = this.currentWarehouseId();
			console.log("id", id);

			this.currentWarehouseId$.next(id);
		});
	}

	public setCompanyId(id: string | undefined) {
		sessionStorage.setItem("companyId", id || "");
		this.currentCompanyId.set(id);
	}

	public getCompanyId() {
		const id = sessionStorage.getItem("companyId");
		return id;
	}

	public changeCompany() {
		const id = this.currentCompanyId();

		this.currentCompanyId$.next(id);

		if (id && id !== undefined && id !== null) {
			this.loadCompanyInfo(id);
		} else {
			this.currentCompanyInfo.set(undefined);
		}
	}

	private loadCompanyInfo(id: string) {
		from(this.supabaseClient.from(TABLE).select("*").eq("id", id))
			.pipe(
				map((response) => {
					if (response.error) {
						throw response.error;
					}

					return response.data[0];
				}),
			)
			.subscribe((company) => {
				this.currentCompanyInfo.set(company);
			});
	}

	public refreshCompany() {
		const id = this.getCompanyId();
		if (id) {
			this.loadCompanyInfo(id);
		}
	}
	public setWarehouseId(id: string | undefined) {
		sessionStorage.setItem("warehouseId", id || "");
		this.currentWarehouseId.set(id);
	}

	public getWarehouseId() {
		const id = sessionStorage.getItem("warehouseId");
		return id;
	}

	public changeWarehouse() {
		const id = this.currentWarehouseId();

		this.currentWarehouseId$.next(id);

		if (id && id !== undefined && id !== null) {
			this.loadCompanyInfo(id);
		} else {
			this.currentCompanyInfo.set(undefined);
		}
	}
}
